import { render, staticRenderFns } from "./LandingCashManagementPage.vue?vue&type=template&id=a45a0654&scoped=true"
import script from "./LandingCashManagementPage.vue?vue&type=script&lang=ts"
export * from "./LandingCashManagementPage.vue?vue&type=script&lang=ts"
import style0 from "./LandingCashManagementPage.vue?vue&type=style&index=0&id=a45a0654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45a0654",
  null
  
)

export default component.exports